"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Sources = require("@studio/constants/Sources");
var _ModalTypes = require("@studio/constants/ModalTypes");
var _Vendor = require("@studio/constants/Vendor");
var _SceneLayouts = require("@studio/constants/SceneLayouts");
var _getEnvVar = require("@studio/environment/getEnvVar");
var _setAttendeeCameraStatus = _interopRequireDefault(require("../attendee/setAttendeeCameraStatus"));
var _setAttendeeMuteStatus = _interopRequireDefault(require("../attendee/setAttendeeMuteStatus"));
var _setAttendeeVoiceIntensity = _interopRequireDefault(require("../attendee/setAttendeeVoiceIntensity"));
var _setAttendeePresence = _interopRequireDefault(require("../attendee/setAttendeePresence"));
var _setAttendeeNetworkHealth = _interopRequireDefault(require("../attendee/setAttendeeNetworkHealth"));
var _addToAttendeeTiles = _interopRequireDefault(require("./addToAttendeeTiles"));
var _setVideoInputDevice = _interopRequireDefault(require("./setVideoInputDevice"));
var _showModal = _interopRequireDefault(require("../modal/showModal/showModal"));
var _showNotification = _interopRequireDefault(require("../notification/showNotification"));
var _setSourceInitializing = _interopRequireDefault(require("../source/setSourceInitializing"));
var _setSourceAsUnassigned = _interopRequireDefault(require("../attendee/setSourceAsUnassigned"));
var _handleAgoraOnStagePriority = _interopRequireDefault(require("./handleAgoraOnStagePriority"));
var _setGenericAudioInputDevice = _interopRequireDefault(require("./setGenericAudioInputDevice"));
var _routeMatch = require("../../utils/routeMatch");
var _types = require("./types");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _getNameInitials = require("@studio/logger/utils/getNameInitials");
var _logAppEntry = require("@studio/logger/datadog/logAppEntry");
var _deviceUtils = require("@studio/logger/utils/deviceUtils");
var _setSceneLayout = _interopRequireDefault(require("../program/setSceneLayout"));
var _sceneBuilder = require("@studio/program/sceneBuilder/sceneBuilder");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var LOG = new _StudioLogger.StudioLogger('initializeAgoraMeeting');

/**
 * Initializes an Agora meeting by configuring the broadcast session and dispatching
 * Redux actions to update attendee state.
 *
 * @param {Object} options - Meeting initialization options
 * @param {Object} options.videoInput - video input
 * @param {string} options.audioInputDeviceId - ID of the audio input device
 * @param {string} options.attendeeId - Unique identifier for the attendee
 * @param {Function} options.disconnectSource - Function to disconnect the source
 * @param {Function} [options.hostEnters] - Analytics function called when host successfully enters
 * @param {Function} [options.endMeetingAsHost] - Analytics function called on meeting errors
 * @param {string} [options.presenterDescription] - Presenter description
 * @param {Function} [options.setAttendeeMuteStatus] - Optional custom setAttendeeMuteStatus function, setAttendeeMuteStatus implementation is different between pro/lite and presenter
 * @param {Function} [options.removePresenter] - Optional function to remove presenter
 * @returns {Function} Redux thunk action that initializes the meeting
 */
function initializeAgoraMeeting(_ref) {
  var videoInput = _ref.videoInput,
    audioInputDeviceId = _ref.audioInputDeviceId,
    attendeeId = _ref.attendeeId,
    disconnectSource = _ref.disconnectSource,
    hostEnters = _ref.hostEnters,
    endMeetingAsHost = _ref.endMeetingAsHost,
    updateSource = _ref.updateSource,
    presenterDescription = _ref.presenterDescription,
    _ref$setProgram = _ref.setProgram,
    setProgram = _ref$setProgram === void 0 ? null : _ref$setProgram,
    _ref$setAttendeeMuteS = _ref.setAttendeeMuteStatus,
    setAttendeeMuteStatus = _ref$setAttendeeMuteS === void 0 ? _setAttendeeMuteStatus["default"] : _ref$setAttendeeMuteS,
    _ref$removePresenter = _ref.removePresenter,
    removePresenter = _ref$removePresenter === void 0 ? null : _ref$removePresenter;
  return (0, _routeMatch.withCurrentParams)(function (dispatch, _ref2, getState) {
    var broadcastId = _ref2.broadcastId;
    var action = {
      type: _types.BROADCAST_CREATE_MEETING,
      request: function () {
        var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(apiClient) {
          var _client$remoteUsers, _client$remoteUsers$f, _client$remoteUsers2, _getState, user, program, proxyType, channelName, _yield$apiClient$toke, token, _yield$import, joinMeeting, appId, actions, _yield$joinMeeting, localVideoTrack, localAudioTrack, client, _yield$Promise$all, _yield$Promise$all2, cameraName, microphoneName, presenterName, remoteActiveCameraCount, remoteUserCount, clearedProgram, _t, _t2;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                _context.p = 0;
                LOG.info('Starting Agora meeting initialization', {
                  attendeeId: attendeeId,
                  channelName: "studio-".concat(broadcastId),
                  videoInputDeviceId: videoInput === null || videoInput === void 0 ? void 0 : videoInput.device,
                  audioInputDeviceId: audioInputDeviceId
                });
                _getState = getState(), user = _getState.user, program = _getState.program, proxyType = _getState.readinessCheck.proxyType;
                channelName = "studio-".concat(broadcastId);
                LOG.info('Generating Agora token', {
                  attendeeId: attendeeId,
                  channelName: channelName
                });
                _context.n = 1;
                return apiClient.token.generateAgoraToken({
                  channelName: channelName,
                  attendeeId: attendeeId
                });
              case 1:
                _yield$apiClient$toke = _context.v;
                token = _yield$apiClient$toke.access_token;
                LOG.info('Agora token generated successfully', {
                  attendeeId: attendeeId
                });
                (0, _logAppEntry.logAppEntry)(user, attendeeId, channelName, _Vendor.VENDOR_AGORA);
                _context.n = 2;
                return Promise.resolve().then(function () {
                  return _interopRequireWildcard(require('@cvent/studio-agora/meeting/joinMeeting'));
                });
              case 2:
                _yield$import = _context.v;
                joinMeeting = _yield$import.joinMeeting;
                appId = (0, _getEnvVar.getEnvVar)('REACT_APP_AGORA_APP_ID');
                actions = {
                  setAttendeeCameraStatus: _setAttendeeCameraStatus["default"],
                  setSourceInitializing: _setSourceInitializing["default"],
                  addToAttendeeTiles: _addToAttendeeTiles["default"],
                  setAttendeeMuteStatus: setAttendeeMuteStatus,
                  setAttendeeVoiceIntensity: _setAttendeeVoiceIntensity["default"],
                  setAttendeePresence: _setAttendeePresence["default"],
                  disconnectSource: disconnectSource,
                  setAttendeeNetworkHealth: _setAttendeeNetworkHealth["default"],
                  handleAudioInputChanged: _setGenericAudioInputDevice["default"],
                  handleVideoInputChanged: _setVideoInputDevice["default"],
                  showNotification: _showNotification["default"],
                  setSourceAsUnassigned: _setSourceAsUnassigned["default"],
                  updateSource: updateSource,
                  handleAgoraOnStagePriority: _handleAgoraOnStagePriority["default"],
                  setVideoInputDevice: _setVideoInputDevice["default"],
                  removePresenter: removePresenter
                };
                LOG.info('Calling Agora joinMeeting', {
                  attendeeId: attendeeId,
                  channelName: channelName,
                  audioInputDevice: audioInputDeviceId,
                  videoInput: videoInput
                });
                _context.n = 3;
                return joinMeeting({
                  channel: channelName,
                  token: token,
                  appId: appId,
                  audioInputDevice: audioInputDeviceId,
                  videoInput: videoInput,
                  attendeeId: attendeeId,
                  actions: actions,
                  dispatch: dispatch,
                  proxyType: proxyType
                });
              case 3:
                _yield$joinMeeting = _context.v;
                localVideoTrack = _yield$joinMeeting.localVideoTrack;
                localAudioTrack = _yield$joinMeeting.localAudioTrack;
                client = _yield$joinMeeting.client;
                LOG.info("Successfully joined Agora channel: ".concat(channelName, " as ").concat(attendeeId));
                _context.n = 4;
                return Promise.all([(0, _deviceUtils.getCameraNameFromId)(videoInput === null || videoInput === void 0 ? void 0 : videoInput.device), (0, _deviceUtils.getMicrophoneNameFromId)(audioInputDeviceId)]);
              case 4:
                _yield$Promise$all = _context.v;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                cameraName = _yield$Promise$all2[0];
                microphoneName = _yield$Promise$all2[1];
                presenterName = (0, _getNameInitials.getNameInitials)("".concat(user.firstName, " ").concat(user.lastName));
                _t = localAudioTrack;
                if (!_t) {
                  _context.n = 5;
                  break;
                }
                _context.n = 5;
                return localAudioTrack.setMuted(true);
              case 5:
                // Start muted
                dispatch(setAttendeeMuteStatus(attendeeId, true));
                remoteActiveCameraCount = (_client$remoteUsers = client.remoteUsers) === null || _client$remoteUsers === void 0 ? void 0 : _client$remoteUsers.filter(function (u) {
                  return u.hasVideo && !u.uid.includes('#content');
                }).length;
                remoteUserCount = (_client$remoteUsers$f = (_client$remoteUsers2 = client.remoteUsers) === null || _client$remoteUsers2 === void 0 ? void 0 : _client$remoteUsers2.filter(function (u) {
                  return !u.uid.includes('#content');
                }).length) !== null && _client$remoteUsers$f !== void 0 ? _client$remoteUsers$f : 0; // If there are no remote users, clear the program for Director Lite
                if (setProgram && remoteUserCount === 0) {
                  clearedProgram = (0, _sceneBuilder.sceneBuilder)(_SceneLayouts.SINGLE, [], []);
                  dispatch(setProgram(_objectSpread(_objectSpread({}, clearedProgram), {}, {
                    style: program.style
                  })));
                  dispatch((0, _setSceneLayout["default"])(_SceneLayouts.SINGLE));
                  LOG.info('No remote users detected, reset program state');
                }

                // prevent joining with camera on when at the camera limit
                if (!localVideoTrack) {
                  _context.n = 9;
                  break;
                }
                if (!(remoteActiveCameraCount && remoteActiveCameraCount >= _Sources.MAX_AGORA_CAMERA_COUNT)) {
                  _context.n = 7;
                  break;
                }
                LOG.info("Camera limit reached. Joining with camera off. Total cameras on: ".concat(remoteActiveCameraCount));
                _context.n = 6;
                return localVideoTrack.setEnabled(false);
              case 6:
                _context.n = 9;
                break;
              case 7:
                _context.n = 8;
                return localVideoTrack.setEnabled(true);
              case 8:
                dispatch((0, _setAttendeeCameraStatus["default"])(attendeeId, true));
              case 9:
                LOG.info('Dispatching attendee state updates', {
                  attendeeId: attendeeId
                });
                dispatch((0, _addToAttendeeTiles["default"])(attendeeId, localVideoTrack));
                dispatch((0, _setSourceInitializing["default"])(attendeeId, {
                  isInitializing: false
                }));
                dispatch((0, _setAttendeePresence["default"])(attendeeId, true, disconnectSource));
                dispatch((0, _handleAgoraOnStagePriority["default"])({
                  agoraClient: client,
                  attendeeId: attendeeId
                }));

                // TODO: Remove attendeeResponse.Attendee.AttendeeId bandaid fix
                // Should be replaced with a vendor-agnostic attendeeId in Redux state.
                // https://jira.cvent.com/browse/WEBINAR-52785
                LOG.info('Calling analytics callbacks', {
                  attendeeId: attendeeId
                });
                hostEnters === null || hostEnters === void 0 || hostEnters({
                  meetingUserId: attendeeId,
                  presenterName: presenterName,
                  presenterTitle: presenterDescription,
                  cameraName: cameraName,
                  microphoneName: microphoneName,
                  meetingType: _Vendor.VENDOR_AGORA
                });
                endMeetingAsHost === null || endMeetingAsHost === void 0 || endMeetingAsHost({
                  meetingUserId: attendeeId
                });
                LOG.info('Agora meeting initialization completed successfully', {
                  attendeeId: attendeeId,
                  channelName: channelName,
                  cameraName: cameraName,
                  microphoneName: microphoneName
                });
                return _context.a(2, {
                  token: token,
                  attendeeId: attendeeId,
                  client: client,
                  meetingId: channelName,
                  attendeeResponse: {
                    Attendee: {
                      AttendeeId: attendeeId
                    }
                  }
                });
              case 10:
                _context.p = 10;
                _t2 = _context.v;
                endMeetingAsHost === null || endMeetingAsHost === void 0 || endMeetingAsHost({
                  error: "Error initializing Agora meeting: ".concat(_t2)
                });
                dispatch((0, _showModal["default"])(_ModalTypes.CREATE_MEETING_ERROR));
                LOG.error('Error initializing Agora meeting:', _t2);
                throw _t2;
              case 11:
                return _context.a(2);
            }
          }, _callee, null, [[0, 10]]);
        }));
        function request(_x) {
          return _request.apply(this, arguments);
        }
        return request;
      }()
    };
    dispatch(action);
  });
}
var _default = exports["default"] = initializeAgoraMeeting;